export default __webpack_public_path__ + "static/media/S-042.f24992f3.png";